import { TParserMicroserviceUtils, TSwaggerfiles } from '../types'

export default (swaggerfiles: TSwaggerfiles): TParserMicroserviceUtils => {
  return {
    getMicroserviceForEntity: entity => {
      const getEndpoint = Object.keys(swaggerfiles.paths).find(path => {
        return path.split('/')[3] === entity
      })
      if (typeof getEndpoint !== 'string') return null
      return getEndpoint.split('/')[1]
    },
  }
}
